import { requiredTtype } from "../../../type/componentsType/TkRequiredText";
import "./_style.scss";

/**
 * 必須マーク部品
 * 【必須】を表示させる部品
 * @param {boolean} lineBreak 項目名ラベルを必須マークの位置で改行させる。
 * @returns TkRequiredText 必須マーク部品
 */
export const TkRequiredText: React.FC<requiredTtype> = (props) => {
  const { lineBreak = true, requiredText = "必須" } = props;
  const className = lineBreak ? "tkRequiredTextLineBreak" : "";

  return <span className={`tkRequiredText ${className}`}>【{requiredText}】</span>;
};
